import styled from 'styled-components';

const StyledLabel = styled.label`
  width: ${props => (props.width ? props.width : '100%')};
  font-size: 14px;
  font-weight: 600;
`;

export default StyledLabel;
